import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { IconGeneratorForm } from '../components/IconGeneratorForm';
import { IconPreview } from '../components/IconPreview';
import { useIconGenerator } from '../hooks/useIconGenerator';
import { ArcheHeader } from '../../../components/ArcheHeader';

export function IconGeneratorPage() {
  const { status, previewUrl, error, generate, save, reset } = useIconGenerator();

  return (
    <div className="flex flex-col h-full">
      <ArcheHeader archeId="arche_icon_generator" title="Icon Generator" />
      <div className="p-6 max-w-2xl mx-auto space-y-6 w-full">
        <p className="text-muted-foreground">Generate professional app-store-style icons with AI</p>

        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Icon Details</CardTitle>
          </CardHeader>
          <CardContent>
            <IconGeneratorForm
              status={status}
              onGenerate={generate}
              onSave={save}
              onReset={reset}
            />
          </CardContent>
        </Card>

        <IconPreview status={status} previewUrl={previewUrl} error={error} />
      </div>
    </div>
  );
}
